import * as runtime from './generated/runtime'

export const REQUEST_OPTIONS: RequestInit | runtime.InitOverrideFunction = { credentials: 'include' }
